import { render } from "./SystemMessage.vue?vue&type=template&id=a9d857b4&scoped=true"
import script from "./SystemMessage.vue?vue&type=script&lang=js"
export * from "./SystemMessage.vue?vue&type=script&lang=js"

import "./SystemMessage.vue?vue&type=style&index=0&id=a9d857b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9d857b4"]])

export default __exports__